export const DEFAULT_PER_PAGE = 25;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
